<script setup lang="ts">
import {
  ToastViewport as ToastViewportComponent,
  type ToastViewportProps,
} from "reka-ui";
import { type HTMLAttributes, computed } from "vue";
import { cn } from "@/lib/utils";

interface Props extends ToastViewportProps {
  class?: HTMLAttributes["class"];
}

const props = defineProps<Props>();

const delegatedProps = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { class: _, ...delegated } = props;
  return delegated;
});
</script>

<template>
  <ToastViewportComponent
    v-bind="delegatedProps"
    :class="
      cn(
        'fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]',
        props.class,
      )
    "
  />
</template>
